import {Component, OnInit, Output} from '@angular/core';
import {DataService} from "../services/data.service";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    constructor(
        private dataService: DataService
    ) {
    }

    ngOnInit() {
        this.dataService.refresh();
    }


}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts